<ngx-spinner bdColor="rgba(0, 0, 0, 0.1)" size = "medium" color = "#000" type = "ball-clip-rotate-pulse" [fullScreen] = "true">
  <p style="color: black" > Loading... </p>
</ngx-spinner>
<router-outlet></router-outlet>

